import React from 'react';
import { Modal } from 'antd';
import AttachmentsManager from '../../../../../../../components/attachmentsManager';
import AttachmentChildren from './AttachmentChildren';
import { useDeleteAttachment } from '../../../../../api/deleteAttachment';
import { useInvalidateRoomAttachments } from '../../../../../api/roomAttachments';
import { useInvalidateRoomInfo } from '../../../../../api/roomInfo';
import { useAcceptanceViewFlatsInvalidate } from '../../../../../api/acceptanceViewFlats';
import { useModalMethods } from '../../../../../shared/packages/modalManager';
import { modalNames } from '../../../../../shared/configs/modal';
import {
  roomAttachmentModalActions,
  roomAttachmentTypeIds,
} from '../../../../../shared/configs/attachments';
import { useUnilateralAttachmentsAction } from '../services/unilateralAttachments';

const AttachmentActions = ({ addressId }) => {
  const attachment = AttachmentsManager.Card.useAttachment();

  const invalidateAttachments = useInvalidateRoomAttachments();
  const invalidateRoomInfo = useInvalidateRoomInfo();
  const invalidateFlatsView = useAcceptanceViewFlatsInvalidate();

  const { mutateAsync } = useDeleteAttachment({
    onSuccess: () => {
      invalidateAttachments({ addressId });
      invalidateRoomInfo({ addressId });
      invalidateFlatsView();
    },
  });

  const { open } = useModalMethods();

  const unilateralAction = useUnilateralAttachmentsAction();

  const onEdit = () => {
    open(modalNames.attachmentsForm, {
      actionType: roomAttachmentModalActions.editAttachment,
      addressId,
      attachment,
    });
  };

  const onRemove = () => {
    const { acceptanceClientId, type, id: attachId } = attachment;

    let content;

    if (
      acceptanceClientId &&
      type.id === roomAttachmentTypeIds.unilateral &&
      unilateralAction.getAttachmentSizeByRecord(acceptanceClientId) === 1
    ) {
      content = `Односторонняя передача должна быть обязательно подтверждена документом. При удалении подтверждающего документа будет удалена запись по приемке с результатом «Односторонняя передача»`;
    }

    Modal.confirm({
      title: 'Удалить документ?',
      content,
      centered: true,
      onOk: async () => {
        await mutateAsync({ addressId, attachId, acceptanceClientId });
      },
      onCancel: () => {},
    });
  };

  return (
    <AttachmentsManager.Card.Actions onRemove={onRemove} onEdit={onEdit}>
      <AttachmentChildren attachment={attachment} parent="actions" />
    </AttachmentsManager.Card.Actions>
  );
};

export default AttachmentActions;
